module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f974.154693d9.svg";